import { useEffect, useRef, useState } from "react";
import { serverFetch } from "../../server";
import { Button, message, Table, Checkbox, Spin, Typography, Card } from "antd";
import LicenseTariff from "./license-tariff";
import { getTariffKindName, getDatPeriodVidName } from "../../extensions/helper";
import { licenseModuleWidget, licenseModuleMessages, licenseModuleAccessControl } from "../../extensions/license";
import { isMobile, menuSize } from "@/extensions/design";
const { Text } = Typography;

const LicenseTariffs = () => {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [editId, setEditId] = useState(null);
  const divRef = useRef(null);

  const getData = () => {
    setLoading(true);
    serverFetch("Tariff")
      .then(data => {
        setItems(data);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  useEffect(getData, []);

  const columns = [
    { title: "#", dataIndex: "id", width: 50, sorter: (a, b) => (a.id ?? 0) - (b.id ?? 0) },
    { title: "Название", dataIndex: "name", sorter: (a, b) => (a.name || "").localeCompare(b.name || "") },
    { title: "Вид", dataIndex: "vid", width: 200, align: "left", render: getTariffKindName, sorter: (a, b) => (a.vid ?? 0) - (b.vid ?? 0) },
    { title: "Срок", dataIndex: "srokVid", width: 120, align: "left", render: (val, record) => `${record.srok} ${getDatPeriodVidName(val) || ""}`.trim(), sorter: (a, b) => { const d = (a.srok ?? 0) - (b.srok ?? 0); return d !== 0 ? d : (a.srokVid ?? 0) - (b.srokVid ?? 0); } },
    { title: "Цена", dataIndex: "price", width: 100, align: "right", render: (val) => val?.toFixed(2), sorter: (a, b) => (a.price ?? 0) - (b.price ?? 0) },
    { title: "Виджет", dataIndex: "permissions", width: 100, align: "center", render: (val) => <Checkbox checked={licenseModuleWidget(val)} disabled />, sorter: (a, b) => (licenseModuleWidget(a.permissions) ? 1 : 0) - (licenseModuleWidget(b.permissions) ? 1 : 0) },
    { title: "Сообщения", dataIndex: "permissions", width: 100, align: "center", render: (val) => <Checkbox checked={licenseModuleMessages(val)} disabled />, sorter: (a, b) => (licenseModuleMessages(a.permissions) ? 1 : 0) - (licenseModuleMessages(b.permissions) ? 1 : 0) },
    { title: "СКД", dataIndex: "permissions", width: 100, align: "center", render: (val) => <Checkbox checked={licenseModuleAccessControl(val)} disabled />, sorter: (a, b) => (licenseModuleAccessControl(a.permissions) ? 1 : 0) - (licenseModuleAccessControl(b.permissions) ? 1 : 0) },
    { title: "Активен", dataIndex: "active", width: 100, align: "center", render: (val) => <Checkbox checked={val} disabled />, sorter: (a, b) => (a.active ? 1 : 0) - (b.active ? 1 : 0) },
    { title: "По умолчанию", dataIndex: "default", width: 150, align: "center", render: (val) => <Checkbox checked={val} disabled />, sorter: (a, b) => (a.default ? 1 : 0) - (b.default ? 1 : 0) },
  ];

  const onClose = (refresh) => {
    setEditId(null);
    refresh && getData();
  };

  const headerSize = divRef.current?.querySelector('.ant-table-thead')?.offsetHeight ?? 0;
  const tableHeight = divRef.current ? (document.documentElement.offsetHeight - headerSize - divRef.current.getBoundingClientRect().top - window.scrollY - 1) : 0;

  return !isMobile ? (
    <div className="sport-form-content license-tariffs">
      <div className="sport-form-title">
        <Button type="primary" onClick={() => setEditId(0)}>
          Новый тариф
        </Button>
      </div>
      <div ref={divRef} style={{ flex: 1 }}>
        <Table
          dataSource={items}
          columns={columns}
          loading={loading}
          rowKey="id"
          size="small"
          pagination={false}
          tableLayout="auto"
          scroll={{ y: tableHeight }}
          onRow={(record) => ({ 
            onClick: () => setEditId(record.id)
          })}
        />
      </div>
      {editId != null && <LicenseTariff id={editId} onClose={onClose} />}
    </div>
  ) : loading ? (
  <div className="report-loading">
    <Spin size="large" />
  </div> ) : (
  <>
    <Button onClick={() => setEditId(0)} style={{width: "96%", marginLeft: "2%", marginRight: "2%"}}> Новый тариф </Button>
    <div style={{ overflowY: "auto", flex: 1, paddingBottom: 8, marginTop: "6px", height: window.innerHeight - menuSize - 65 }}>
      {items?.map((item) => {
        return (
          <Card key={item.id} className="stock-card" onClick={() => { setEditId(item.id) }}
            style={{ borderLeft: `4px solid ${(item.active) ? "#2f6f00" : "#d9d9d9"}`, marginBottom: "6px"}}>
            <div className="license-orders-item-line-double-1-02">
              <Text>{item.name}</Text>
              <Text strong style={{ textAlign: "right" }}> #{item.id} </Text>
            </div>

            <div className="license-orders-item-line-triple">
              <Text>Срок: {`${item.srok} ${getDatPeriodVidName(item.srokVid) || ""}`.trim()}</Text>
              <Text style={{textAlign: "center"}}>Вид: {getTariffKindName(item.vid)} </Text>
              <Text style={{ textAlign: "right" }}> Цена: {item.price} </Text>
            </div>
          </Card>
        );
      })}
      {items.length === 0 && !loading && (
        <div style={{ textAlign: "center", marginTop: 20, fontSize: 14 }}> Нет данных </div>
      )}
    </div>
    {editId != null && <LicenseTariff id={editId} onClose={onClose} />}
  </>
  );
};

export default LicenseTariffs;

